import { render, staticRenderFns } from "./callback.vue?vue&type=template&id=fddd472c&scoped=true&"
import script from "./callback.vue?vue&type=script&lang=js&"
export * from "./callback.vue?vue&type=script&lang=js&"
import style0 from "./callback.vue?vue&type=style&index=0&id=fddd472c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddd472c",
  null
  
)

export default component.exports